import { RouterState, RouterStateModel } from '@ngxs/router-plugin';
import { Selector } from '@ngxs/store';

import { StoreRouterStateModel } from '../models';

export class RouteSelectors {
  @Selector([RouterState])
  static data({ state }: RouterStateModel<StoreRouterStateModel>) {
    return state?.data ?? null;
  }

  @Selector([RouterState])
  static getPathParamByKey({ state }: RouterStateModel<StoreRouterStateModel>) {
    return (pathParamKey: string) => state?.params[pathParamKey] ?? null;
  }

  @Selector([RouterState])
  static getQueryParamByKey({
    state,
  }: RouterStateModel<StoreRouterStateModel>) {
    return (queryParamKey: string) => state?.queryParams[queryParamKey] ?? null;
  }

  @Selector([RouterState])
  static url({ state }: RouterStateModel<StoreRouterStateModel>) {
    return state?.url;
  }

  @Selector([RouterState])
  static urlLeafSegment({ state }: RouterStateModel<StoreRouterStateModel>) {
    return state?.url.split('/').pop();
  }

  @Selector([RouteSelectors.url, RouteSelectors.data])
  static routeData(
    url: string | undefined,
    data: StoreRouterStateModel['data'] | null,
  ) {
    return {
      url: url || '',
      data,
    };
  }
}
